/* src/components/Solar/TotalPowerOutage.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	children,
	claim_component,
	claim_element,
	claim_space,
	claim_text,
	create_component,
	destroy_component,
	detach,
	element,
	init,
	insert_hydration,
	mount_component,
	safe_not_equal,
	set_data,
	space,
	text,
	transition_in,
	transition_out
} from "svelte/internal";

import Icon from '../Icon/Icon.svelte';
import gql from 'nanographql';
import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';
import { onMount } from 'svelte';

function create_fragment(ctx) {
	let div3;
	let h2;
	let t0;
	let t1;
	let p0;
	let t2;
	let t3_value = /*totalCustomers*/ ctx[0].toLocaleString() + "";
	let t3;
	let t4;
	let t5;
	let t6;
	let t7;
	let div2;
	let div1;
	let a;
	let span0;
	let t8;
	let t9;
	let icon;
	let t10;
	let div0;
	let p1;
	let t11;
	let t12;
	let p2;
	let span1;
	let t13_value = /*totalCustomersOut*/ ctx[1].toLocaleString() + "";
	let t13;
	let current;
	icon = new Icon({ props: { icon: "light-bulb" } });

	return {
		c() {
			div3 = element("div");
			h2 = element("h2");
			t0 = text("Power Outages");
			t1 = space();
			p0 = element("p");
			t2 = text("Currently, ");
			t3 = text(t3_value);
			t4 = text(" customers are being tracked in ");
			t5 = text(/*name*/ ctx[3]);
			t6 = text(".");
			t7 = space();
			div2 = element("div");
			div1 = element("div");
			a = element("a");
			span0 = element("span");
			t8 = text("Learn more");
			t9 = space();
			create_component(icon.$$.fragment);
			t10 = space();
			div0 = element("div");
			p1 = element("p");
			t11 = text("Customers Out:");
			t12 = space();
			p2 = element("p");
			span1 = element("span");
			t13 = text(t13_value);
			this.h();
		},
		l(nodes) {
			div3 = claim_element(nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			h2 = claim_element(div3_nodes, "H2", { class: true });
			var h2_nodes = children(h2);
			t0 = claim_text(h2_nodes, "Power Outages");
			h2_nodes.forEach(detach);
			t1 = claim_space(div3_nodes);
			p0 = claim_element(div3_nodes, "P", {});
			var p0_nodes = children(p0);
			t2 = claim_text(p0_nodes, "Currently, ");
			t3 = claim_text(p0_nodes, t3_value);
			t4 = claim_text(p0_nodes, " customers are being tracked in ");
			t5 = claim_text(p0_nodes, /*name*/ ctx[3]);
			t6 = claim_text(p0_nodes, ".");
			p0_nodes.forEach(detach);
			t7 = claim_space(div3_nodes);
			div2 = claim_element(div3_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			a = claim_element(div1_nodes, "A", { href: true });
			var a_nodes = children(a);
			span0 = claim_element(a_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t8 = claim_text(span0_nodes, "Learn more");
			span0_nodes.forEach(detach);
			a_nodes.forEach(detach);
			t9 = claim_space(div1_nodes);
			claim_component(icon.$$.fragment, div1_nodes);
			t10 = claim_space(div1_nodes);
			div0 = claim_element(div1_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			p1 = claim_element(div0_nodes, "P", { class: true });
			var p1_nodes = children(p1);
			t11 = claim_text(p1_nodes, "Customers Out:");
			p1_nodes.forEach(detach);
			t12 = claim_space(div0_nodes);
			p2 = claim_element(div0_nodes, "P", { class: true });
			var p2_nodes = children(p2);
			span1 = claim_element(p2_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t13 = claim_text(span1_nodes, t13_value);
			span1_nodes.forEach(detach);
			p2_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h2, "class", "heading-sm heading-sm--wide");
			attr(span0, "class", "energy-loss__percentage svelte-1w4j378");
			attr(a, "href", /*powerOutageSlug*/ ctx[2]);
			attr(p1, "class", "energy-loss__label svelte-1w4j378");
			attr(span1, "class", "energy-loss__data__num svelte-1w4j378");
			attr(p2, "class", "energy-loss__data svelte-1w4j378");
			attr(div0, "class", "energy-loss__content");
			attr(div1, "class", "energy-loss__wrapper svelte-1w4j378");
			attr(div2, "class", "energy-loss");
			attr(div3, "class", "col-xl-4 col-lg-5");
		},
		m(target, anchor) {
			insert_hydration(target, div3, anchor);
			append_hydration(div3, h2);
			append_hydration(h2, t0);
			append_hydration(div3, t1);
			append_hydration(div3, p0);
			append_hydration(p0, t2);
			append_hydration(p0, t3);
			append_hydration(p0, t4);
			append_hydration(p0, t5);
			append_hydration(p0, t6);
			append_hydration(div3, t7);
			append_hydration(div3, div2);
			append_hydration(div2, div1);
			append_hydration(div1, a);
			append_hydration(a, span0);
			append_hydration(span0, t8);
			append_hydration(div1, t9);
			mount_component(icon, div1, null);
			append_hydration(div1, t10);
			append_hydration(div1, div0);
			append_hydration(div0, p1);
			append_hydration(p1, t11);
			append_hydration(div0, t12);
			append_hydration(div0, p2);
			append_hydration(p2, span1);
			append_hydration(span1, t13);
			current = true;
		},
		p(ctx, [dirty]) {
			if ((!current || dirty & /*totalCustomers*/ 1) && t3_value !== (t3_value = /*totalCustomers*/ ctx[0].toLocaleString() + "")) set_data(t3, t3_value);
			if (!current || dirty & /*name*/ 8) set_data(t5, /*name*/ ctx[3]);

			if (!current || dirty & /*powerOutageSlug*/ 4) {
				attr(a, "href", /*powerOutageSlug*/ ctx[2]);
			}

			if ((!current || dirty & /*totalCustomersOut*/ 2) && t13_value !== (t13_value = /*totalCustomersOut*/ ctx[1].toLocaleString() + "")) set_data(t13, t13_value);
		},
		i(local) {
			if (current) return;
			transition_in(icon.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(icon.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div3);
			destroy_component(icon);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { pageType = '' } = $$props;
	let { id } = $$props;
	let { powerOutageSlug } = $$props;
	let { name = '' } = $$props;
	let { totalCustomers = 0 } = $$props;
	let { totalCustomersOut = 0 } = $$props;
	let totalOutageCustomers = 0;
	let totalServedCustomers = 0;
	let egKey = '';

	const getProviderOutage = gql`
    query providerOutages($id: Int!) {
      provider: allProviderOutageData(condition: { providerId: $id }) {
        nodes {
          outageCustomers
          servedCustomers
        }
      }
      outages: allProviderCountyOutageData(condition: { providerId: $id }) {
        nodes {
          outageCustomers
          servedCustomers
        }
      }
    }
  `;

	const getCountyOutage = gql`
    query countyOutage($id: Int!) {
      outages: allCountyOutageData(condition: { countyId: $id }) {
        nodes {
          outageCustomers
          servedCustomers
        }
      }
    }
  `;

	const getStateOutage = gql`
    query stateOutage($id: Int!) {
      outages: allProviderStateOutageData(condition: { stateId: $id }) {
        nodes {
          outageCustomers
          servedCustomers
        }
      }
    }
  `;

	const graphql = getGraphqlClient();

	// handle state
	const handleStatePageOnMount = async id => {
		const stateOutages = await graphql(getStateOutage({ id }), { 'eg-key': egKey });

		if (stateOutages.errors) {
			errors = stateOutages.errors;
		}

		const outages = stateOutages.data.outages.nodes;

		outages.forEach(({ outageCustomers, servedCustomers }) => {
			totalOutageCustomers += Number(outageCustomers);
			totalServedCustomers += Number(servedCustomers);
		});

		$$invalidate(1, totalCustomersOut = totalOutageCustomers);
		$$invalidate(0, totalCustomers = totalServedCustomers);
	};

	// handles both city and county
	const handleCountyPageOnMount = async id => {
		const countyOutages = await graphql(getCountyOutage({ id }), { 'eg-key': egKey });

		if (countyOutages.errors) {
			errors = countyOutages.errors;
		}

		const outages = countyOutages.data.outages.nodes;

		outages.forEach(({ outageCustomers, servedCustomers }) => {
			totalOutageCustomers += Number(outageCustomers);
			totalServedCustomers += Number(servedCustomers);
		});

		$$invalidate(1, totalCustomersOut = totalOutageCustomers);
		$$invalidate(0, totalCustomers = totalServedCustomers);
	};

	// handle provder
	const handleProviderPageOnMount = async id => {
		const providerOutages = await graphql(getProviderOutage({ id }), { 'eg-key': egKey });

		if (providerOutages.errors) {
			errors = providerOutages.errors;
		}

		const outages = providerOutages.data.outages.nodes;

		outages.forEach(({ outageCustomers, servedCustomers }) => {
			totalOutageCustomers += Number(outageCustomers);
			totalServedCustomers += Number(servedCustomers);
		});

		$$invalidate(1, totalCustomersOut = totalOutageCustomers);
		$$invalidate(0, totalCustomers = totalServedCustomers);

		if (provider) {
			const unknownData = {
				servedCustomers: provider.servedCustomers - totalServedCustomers > 0
				? provider.servedCustomers - totalServedCustomers
				: 0,
				outageCustomers: provider.outageCustomers - totalOutageCustomers > 0
				? provider.outageCustomers - totalOutageCustomers
				: 0
			};

			if (unknownData.servedCustomers > 0 || unknownData.outageCustomers > 0) providerOutageData.push(unknownData);
			if (provider.servedCustomers > totalCustomers) $$invalidate(0, totalCustomers = provider.servedCustomers);
			if (provider.outageCustomers > totalCustomersOut) $$invalidate(1, totalCustomersOut = provider.outageCustomers);
		}
	};

	onMount(async () => {
		const egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;

		if (pageType === 'state' && id) {
			await handleStatePageOnMount(id);
		}

		if (pageType === 'county' && id) {
			await handleCountyPageOnMount(id);
		}

		if (pageType === 'provider' && id) {
			await handleProviderPageOnMount(id);
		}
	});

	$$self.$$set = $$props => {
		if ('pageType' in $$props) $$invalidate(4, pageType = $$props.pageType);
		if ('id' in $$props) $$invalidate(5, id = $$props.id);
		if ('powerOutageSlug' in $$props) $$invalidate(2, powerOutageSlug = $$props.powerOutageSlug);
		if ('name' in $$props) $$invalidate(3, name = $$props.name);
		if ('totalCustomers' in $$props) $$invalidate(0, totalCustomers = $$props.totalCustomers);
		if ('totalCustomersOut' in $$props) $$invalidate(1, totalCustomersOut = $$props.totalCustomersOut);
	};

	return [totalCustomers, totalCustomersOut, powerOutageSlug, name, pageType, id];
}

class TotalPowerOutage extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			pageType: 4,
			id: 5,
			powerOutageSlug: 2,
			name: 3,
			totalCustomers: 0,
			totalCustomersOut: 1
		});
	}
}

export default TotalPowerOutage;